import type {EditorView} from "prosemirror-view";
import type {ResolvedPos} from "prosemirror-model";

import {createImageUploadingPlaceholder} from "./createImageNode";
import {placeImage, uploadFileToS3} from "../../../utils/file/ImageUploadLogic";
import {compressImage} from '../../../utils/file/compressImage';

import {getEditorFileUploadManager} from "../../background-services/editorFileUploadManager";
import {logErrorToSentry} from "../../../utils/errors/logErrorToSentry";
import {unsavedChangesManager} from "../../../stores/UnsavedChangesManager";
import { IStorageService } from "../../../platform/services/storage/StorageService";

export const uploadImageWithProgressBar = (
    view: EditorView, 
    file: File, 
    storageService: IStorageService,
    tenantId: string,
    targetPos?: number | ResolvedPos, 
    length: number = 0
) => {
    const imageNode = createImageUploadingPlaceholder(file);
    let tr = placeImage(view, imageNode, targetPos, length);

    view.focus();
    view.dispatch(tr.scrollIntoView());

    unsavedChangesManager.declareUnsavedChanges();
    getEditorFileUploadManager().uploadFile(imageNode, file).catch(logErrorToSentry).then(() => {
        unsavedChangesManager.declareNoUnsavedChanges()
    });
};